var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReject = function SvgReject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C21C1C",
    d: "M32 5.332c-14.72 0-26.667 11.947-26.667 26.667 0 14.72 11.947 26.666 26.667 26.666 14.72 0 26.666-11.946 26.666-26.666S46.72 5.332 32 5.332m0 48c-11.787 0-21.334-9.547-21.334-21.333 0-4.934 1.68-9.467 4.507-13.067l29.893 29.893A21.073 21.073 0 0 1 32 53.332m16.826-8.267L18.933 15.172A21.073 21.073 0 0 1 32 10.665c11.786 0 21.333 9.547 21.333 21.334 0 4.933-1.68 9.466-4.507 13.066"
  })));
};
export default SvgReject;